<template>
  <f7-page
    :page-content="true"
  >
    <f7-navbar
      class="bg-madai"
    >
      <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      <f7-nav-title class="text-white">Información de envío</f7-nav-title>
    </f7-navbar>

    <div v-if="storage.guardarEnvio" class="text-center fs-16 alert alert-danger">Hay cambios sin guardar...</div>

    <f7-list no-hairlines-md>
      <f7-list-input
        class="required"
        label="Nombre completo"
        type="text"
        placeholder="Escribe el nombre completo"
        :value="storage.usuario.envio.nombre"
        @input="storage.usuario.envio.nombre = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Dirección línea 1"
        type="text"
        placeholder="Escribe tu dirección"
        :value="storage.usuario.envio.direccion1"
        @input="storage.usuario.envio.direccion1 = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        label="Dirección línea 2"
        type="text"
        placeholder="Escribe tu dirección"
        :value="storage.usuario.envio.direccion2"
        @input="storage.usuario.envio.direccion2 = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Estado"
        type="text"
        placeholder="Escribe el estado"
        :value="storage.usuario.envio.estado"
        @input="storage.usuario.envio.estado = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Ciudad / Municipio"
        type="text"
        placeholder="Escribe la ciudad / estado"
        :value="storage.usuario.envio.ciudad"
        @input="storage.usuario.envio.ciudad = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Código Postal"
        type="text"
        placeholder="Escribe el código postal"
        :value="storage.usuario.envio.cp"
        @input="storage.usuario.envio.cp = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Correo"
        type="email"
        placeholder="Escribe el correo"
        :value="storage.usuario.envio.email"
        @input="storage.usuario.envio.email = $event.target.value"
      ></f7-list-input>

      <f7-list-input
        class="required"
        label="Teléfono"
        type="text"
        placeholder="Escribe el teléfono"
        :value="storage.usuario.envio.telefono"
        @input="storage.usuario.envio.telefono = $event.target.value"
      ></f7-list-input>

      <f7-list-item>
        <f7-button class="margin-auto" fill @click="actualizarEnvio()" :disabled="
          storage.usuario.envio.nombre === '' ||
          storage.usuario.envio.direccion1 === '' ||
          storage.usuario.envio.estado === '' ||
          storage.usuario.envio.ciudad === '' ||
          storage.usuario.envio.cp === '' ||
          storage.usuario.envio.email === '' ||
          storage.usuario.envio.telefono === ''
        ">
          Guardar
        </f7-button>
      </f7-list-item>
    </f7-list>

    <navbar-bottom />
  </f7-page>
</template>

<script>
import navbarBottom from '@/components/navbar-bottom'

export default {
  components: {
    navbarBottom
  },
  watch: {
    'storage.usuario.envio': {
      deep: true,
      handler () {
        this.storage.guardarEnvio = true
      }
    }
  },
  methods: {
    async actualizarEnvio () {
      try {
        await this.$api.envio.guardar(this.storage.usuario.envio)
        this.storage.guardarEnvio = false
        this.$f7.dialog.alert('Información actualizada.', `MADAI`, () => {})
      } catch (err) {
        this.$f7.dialog.alert('No se pudo actualizar la información.', `MADAI`, () => {})
      }
    }
  }
}
</script>
